module.exports = __webpack_public_path__ + "static/Chunglogo-3d26147bd6c747df84d7084cc8a5fead.png";